import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import leadsActions from '@/redux/leads/actions';
import leadActions from '@/redux/lead/actions';
import gmapsActions from '@/redux/gmaps/actions';
import intakeFormActions from '@/redux/intakeForm/actions';
import { Loader } from '@/components';
import { dateToString, formatNumberToLocale, timeToString } from '@/utils/common';
import { LeadStatusChoices, ProjectTypeChoices } from '@/constants/Leads';

const AsyncLeads = Loadable({
  loader: () => import('./Leads'),
  loading: Loader,
});

const mapStateToProps = ({ leads, gmaps, auth }) => ({
  isFetching: leads.isFetching,
  isSummaryFetching: leads.isSummaryFetching,
  leads: leads.data,
  summaryData: leads.summaryData,
  activeTab: leads.activeTab,
  tableOptions: leads.tableOptions,
  tableLeadsData: leads.data.map((lead) => {
    const systemSize = lead.design_data?.proposed_system_size ?? lead.property?.calculated_system_size;

    return Object.assign(
      {},
      {
        key: lead.id,
        id: lead.id,
        name: lead.name,
        updated: `${dateToString(lead.updated)} ${timeToString(lead.updated)}`,
        lead_status: LeadStatusChoices(lead.lead_status),
        address: lead.property?.site_address ?? 'N/A',
        proposal_type: ProjectTypeChoices(lead.proposal_type),
        system_size: formatNumberToLocale({
          number: systemSize,
          style: 'decimal',
          maximumFractionDigits: 0,
          minimumFractionDigits: 0,
        }),
        created: dateToString(lead.created),
        location: {
          lat: lead.property.latitude,
          lng: lead.property.longitude,
        },
        superAdmin: auth.permissions.superAdmin,
        organization: lead.organization_name,
        assigned_user: lead.associated_user_name,
      }
    );
  }),
  gmaps,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchLeads: leadsActions.fetchLeads,
      fetchLeadsSummary: leadsActions.fetchLeadsSummary,
      changeTab: leadsActions.changeTab,
      tableChange: leadsActions.tableChange,
      saveZoom: gmapsActions.saveZoom,
      saveCoordinates: gmapsActions.saveCoordinates,
      deleteLead: leadActions.deleteLead,
      initNewLead: intakeFormActions.initNewLead,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AsyncLeads);
